export default "__VITE_ASSET__LlQbDiE3__"